<template>
  <ProductsTable :keys="keys"
                 :items="basket"
                 :totals="totals"
                 :delivery="delivery"
                 actions
                 @plus="basketPlus"
                 @minus="basketMinus"
                 @remove="basketRemove"
                 @clear="basketClear"
  />
</template>

<script>

import ProductsTable from '@/components/ProdcutsTable';

export default {
  name: 'CheckoutTable',
  components: { ProductsTable },
  props: {
    delivery: { type: Number, default: null, required: false }
  },
  computed: {
    keys() {
      return ['name', 'quantity', 'weight', 'price', 'sum'];
    },
    totals() {
      const { price, quantity, weight } = this.$store.getters['basket/totals'];
      const out = { price, quantity, weight };
      out.price += this.delivery > 0 ? this.delivery : 0;
      return out;
    },
    basket() {
      return this.$store.state.basket.items
        .filter((item) => item && item.commodity)
        .map((item) => ({
          ...item,
          item: item.commodity,
          sum: item.commodity.priceFinal * item.quantity,
          weight: item.commodity.weight * item.quantity,
        }));
    },
  },
  methods: {
    basketPlus(item) {
      this.$store.dispatch('basket/plus', item);
    },
    basketRemove(item) {
      this.$store.dispatch('basket/remove', item);
    },
    basketMinus(item) {
      this.$store.dispatch('basket/minus', item);
    },
    basketClear() {
      this.$store.commit('basket/clear');
    }
  }
};
</script>
